import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

function Banner({
  bannerBgColor,
  bannerImgUrl,
  bannerHeader,
  bannerText,
  buttonColor,
  actionText,
}) {
  const navigate = useNavigate();

  const upSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const upMd = useMediaQuery((theme) => theme.breakpoints.up("md"));

  let padding = 4;
  if (upSm) {
    padding = 6;
  }
  if (upMd) {
    padding = 10;
  }

  let spacing = 4;
  if (upSm) {
    spacing = 6;
  }
  if (upMd) {
    spacing = 8;
  }

  return (
    <Stack direction="row" sx={{ backgroundColor: bannerBgColor }}>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        useFlexGap
        flexWrap="wrap"
        width="100%"
        p={padding}
        spacing={spacing}
      >
        <Stack width={upMd ? "50%" : "90%"} maxWidth={800}>
          <img src={bannerImgUrl} alt="promotion" width="100%" />
        </Stack>

        <Stack alignItems="center" spacing={4}>
          <Typography
            variant="h2"
            color="common.white"
            align="center"
            sx={{ userSelect: "none" }}
          >
            {bannerHeader}
          </Typography>
          <Typography
            variant="h5"
            color="common.white"
            align="center"
            sx={{ userSelect: "none" }}
          >
            {bannerText}
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/dang-ki-hoc-thu")}
            style={{ backgroundColor: buttonColor }}
          >
            {actionText}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

Banner.propTypes = {
  bannerBgColor: PropTypes.string.isRequired,
  bannerImgUrl: PropTypes.string.isRequired,
  bannerHeader: PropTypes.string.isRequired,
  bannerText: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
};

export default Banner;
